import styled from 'styled-components';
import {theme} from '@styles/theme';

export const ModalWrapper = styled.div`
  width: 432px;
`;

export const ModalContent = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 24px;
  padding: 24px;
  justify-content: center;
  border-top: 1px solid ${theme.colors.basic06};
`;

export const DeleteUserWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const DeleteUsersEmailsWrapper = styled.div`
  line-height: 16px;
`;
